import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(auth)/password_resets/new/page.tsx");
